export enum QuestionType {
    Input=0,
    InputArray=1,
    YesNo=2,
    Custom=3,
    Borrower=4,
    MoreLess=5
}



// WEBPACK FOOTER //
// ./src/app/enums/question-type.enum.ts